<template>
  <div>
    <cx-query-condition :loading="loading" @query="query"
                        @reset='resetQc'>
      <el-row>
        <el-col :span="5">
          <el-form-item label="姓名">
            <cx-input v-model="qc.list.emp_name"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="流程号">
            <cx-input v-model="qc.list.flow_number"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="工号">
            <cx-input v-model="qc.list.work_no"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="状态">
            <cx-select v-model="qc.list.record_status" :options="list.record_status" />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="流程">
            <cx-select v-model="qc.list.flow_type" :options="list.flow_type" />
          </el-form-item>
        </el-col>
      </el-row>
    </cx-query-condition>

    <el-table v-loading="loading"
              :data="data.list"
              border
              highlight-page-row
              size='mini'
              style="width:100%"
              @selection-change='handleSelectionChange'>
      <el-table-column type="selection" width="50"/>
      <el-table-column type="index" label="序号" width="50" header-align="center" align="center"/>
      <el-table-column prop="flow_number" label="流程号" width="120"/>
      <el-table-column prop="emp_name" label="员工" width="120"/>
      <el-table-column prop="flow_type" label="流程" width="100" :formatter="Filter.fmProcessType"/>
      <el-table-column prop="record_status" label="状态" width="100" :formatter="Filter.fmProcessStatus"/>
      <el-table-column prop="effect_time" label="生效时间" width="150"/>
      <el-table-column prop="create_time" label="创建时间" width="150"/>
      <el-table-column prop="comment" label="备注" width="250"/>
    </el-table>

    <cx-pagination :pageData="qc.list"
                   @sizeChange='query'
                   @pageChange='query' />
    
    <cx-btn-group>
      <el-button type="success" icon="el-icon-refresh"
                 size='mini' @click='query'>刷新</el-button>
      <el-button type="primary" icon="el-icon-check"
                 size='mini' @click='yes'>确认</el-button>
      <el-button type="warning" icon="el-icon-close"
                 size='mini' @click='no'>撤销</el-button>
    </cx-btn-group>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      selectedRows: [],
      list: {
        record_status: [],
        flow_type: [],
      },
      URL: { // 各请求接口
        LIST: '/changes/list',
        MODIFY: '/changes/modify',
        DICT: '/sys-dictionaries/list',
      },
      data: {
        list: []
      },
      qc: {
        list: {
          sort: 'flow_number',
          order: 'desc',
          total: this.CONST.PAGINATION.TOTAL,
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.ROWS,
        },
        modify: {
          id: null,
          record_status: null,
        },
        dict: {
          rows: 99999
        },
        
      }
    }
  },
  methods: {
    query() {
      this.loading = true;
      var qc = this._.cloneDeep(this.qc.list);
      qc.record_status = qc.record_status? qc.record_status : null;
      qc.flow_type = qc.flow_type? qc.flow_type : null;

      this.post(this.URL.LIST, qc).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.data.success) {
              if (res.data.rows) {
                var STATUS = this.CONST.EMPLOYEE_STATUS
                res.data.rows.forEach(row => {
                  row.sex_name = row.sex == 1? '男': '女';

                  for (var i = 0; i < this.CONST.EMPLOYEE_STATUS.length; i++) {
                    if (STATUS[i].id == row.status) {
                      row.status_name = STATUS[i].name;
                      break;
                    }
                  }
                })
              }
              
              this.data.list = res.data.rows;
              this.qc.list.total = res.data.total;
            }
          }
        }
      );
    },
    // queryDict() {
    //   this.post(this.URL.DICT, this.qc.dict).then(
    //     res => {
    //       if (res) {
    //         if (res.data.success) {
    //           res.data.rows.forEach(row => {
    //             switch(row.type) {
    //               case 42: // 人事流程状态
    //                 this.list.record_status.push(row);
    //                 break;
    //               case 43: // 人事流程
    //                 this.list.flow_type.push(row);
    //             }
    //           })
    //         }
    //       }
    //     }
    //   )
    // },
    yes() {
      
      if (this.selectedRows.length == 1) {
        var row = this.selectedRows[0];

        if (row.record_status == 2) {
          this.qc.modify.id = row.id;
          this.qc.modify.record_status = 1;
          this.qc.modify.emp_id = row.emp_id;
          this.qc.modify.flow_type = row.flow_type;
          this.qc.modify.effect_time = row.effect_time;
          
          this.qc.modify.comment = row.comment;

          var qc = this._.cloneDeep(this.qc.modify);

          this.post(this.URL.MODIFY, this.qc.modify).then(
            res => {
              if (res) {
                if (res.data.success) {
                  this.success(res.data.msg);
                  this.qc.list.page = 1;
                  this.query();
                }
              }
            }
          );
        } else {
          this.warning('请选择“未生效”的记录进行操作');
        }
        
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR);
      }
      
    },
    no() {
      if (this.selectedRows.length == 1) {
        var row = this.selectedRows[0];

          this.qc.modify.id = row.id;
          this.qc.modify.record_status = 3;
          // this.qc.modify.emp_id = row.emp_id;
          // this.qc.modify.flow_type = row.flow_type;
        if (row.record_status == 2) {
          this.post(this.URL.MODIFY, this.qc.modify).then(
            res => {
              if (res) {
                if (res.data.success) {
                  this.success(res.data.msg);
                  this.qc.list.page = 1;
                  this.query();
                }
              }
            }
          );
        } else {
          this.warning('请选择“未生效”的记录进行操作');
        }
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR);
      }
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    resetQc() {
      this.qc.list.emp_name = null;
      this.qc.list.flow_number = null;
      this.qc.list.work_no = null;
      this.qc.list.record_status = null;
      this.qc.list.flow_type = null;
    },
  },
  mounted() {
    this.query();
    this.Util.fillDictList(
      [42, 43],
      [this.list.record_status, this.list.flow_type]);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/web/human_affairs/process/list.vue